import { ReactNode } from "react";
import { createFastContext } from "../../contexts/createFastContext";
import { IUnitOverview } from "../../util/store/site/constants";
import { removeProperty } from "../../util/varibles/global";
import { IFishGroup } from "../../util/varibles/interface";
import { FILTER_ID } from "./Filter";

interface IState {
    unitsFilter: { [id: string]: (item: IUnitOverview) => boolean }
    fishgroupFilter: { [id: string]: (item: IFishGroup) => boolean }
    filterOpen: boolean
    isClosed: boolean
}

const {
    Provider,
    useStore: useSiteOverview,
    setStore: setSiteOverview,
    getStore: getSiteOverview,
    callEvent: callEventSiteOverview
} = createFastContext<IState, {
    addUnitsFilter: (value: { [id: string]: (item: IUnitOverview) => boolean }) => void,
    removeUnitsFilter: (value: FILTER_ID) => void
}>({
    unitsFilter: {},
    fishgroupFilter: {},
    filterOpen: false,
    isClosed: false
});

const SiteOverviewProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    return <Provider
        props={args}
        event={{
            addUnitsFilter: (value, { set }) => {
                set(({ unitsFilter: prev }) => ({ unitsFilter: { ...prev, ...value } }))
            },
            removeUnitsFilter: (value, { set }) => {
                set(({ unitsFilter: prev }) => ({ unitsFilter: removeProperty(prev, value) }))
            }
        }}
    >
        <div className="flex h-full">
            {children}
        </div>
    </Provider>
}


export { callEventSiteOverview, getSiteOverview, setSiteOverview, SiteOverviewProvider, useSiteOverview };

